// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewport[data-v-118d4020] {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  background: #242424;\n}\n.divider[data-v-118d4020] {\n  height: 2px;\n  background: #c1c1c1;\n}\n.navbar-buttons[data-v-118d4020] {\n  width: 100%;\n}\n@media (min-width: 992px) {\n.navbar-buttons[data-v-118d4020] {\n    width: auto;\n}\n}\n.colorBlanco[data-v-118d4020] {\n  filter: invert(98%) sepia(0%) saturate(0%) hue-rotate(208deg) brightness(103%) contrast(104%);\n}", ""]);
// Exports
module.exports = exports;
